import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { JobApplicationStatusKey } from '@restworld/utility-types';

import { CandidateModalVariantType } from '../../job-listing/employer-job-listing.atoms';
import { useUpdateJobApplicationMutation } from '../../job-listing/hooks/use-update-job-application';
import { useEmployerJobApplicationQueryKey } from '../../job-listing/hooks/use-employer-job-applications';

function useUpdateEmployerViewedCandidateStatus({
  statusKey,
  variant,
  restaurantId,
  workerId,
  jobPositionId,
}: {
  variant: CandidateModalVariantType;
  statusKey: JobApplicationStatusKey;
  workerId: string;
  restaurantId?: string;
  jobPositionId?: string;
}) {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset } = useUpdateJobApplicationMutation();
  const jobApplicationQueryKey = useEmployerJobApplicationQueryKey();

  useEffect(() => {
    if (
      (variant === 'spontaneous_candidate' && statusKey !== 'worker_jp_viewed_by_employer') ||
      statusKey === 'worker_jp_in_shortlist'
    ) {
      mutate({
        params: {
          status_key: 'worker_jp_viewed_by_employer',
        },
        workerId,
        restaurantId,
        jobPositionId,
      });
    }
  }, [jobPositionId, mutate, restaurantId, statusKey, variant, workerId]);

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({
        queryKey: jobApplicationQueryKey,
      });
      reset();
    }
  }, [isSuccess, jobApplicationQueryKey, queryClient, reset]);
}

export default useUpdateEmployerViewedCandidateStatus;
